module.exports = __webpack_public_path__ + "img/footer1.a0d5d0f9.png";